import { apiConfig } from "../config/apiConfig";
import { ScreenType } from "../location-search-map/models/ScreenType";
import { reportScreenSize } from "../location-search-map/reportScreenSize";
import { replaceLocalLogoLink } from "./replaceLocalLogoLink";
import { getBrandJSON } from "../util/locationBasedBrandJson";
import { apiCaching } from "../config/cachingConfig";
import { cachedAPIWrapper, getCachedAPIResponse } from "../apiCaching/apiWrapper";
import { Footer } from "../footer/footer";
import { requestLogger } from "../api/apiTester";
import { FranchiseDetail } from "../location-search-map/models/FranchiseDetail";
import { DomainIdentifier } from "./domainService";
import { localizationMobileDBATitle, localizationTagLine, localizationTagUpadation } from "./localizationTag";
import { SiteConfigPathParams } from "../apiCaching/GET-Requests/interface/siteConfigJson/siteConfigJsonInterface";
import { TechAvailabilityParams } from "../apiCaching/GET-Requests/interface/techAvaliblity/techAvaliblityInterface";
import { changeWhiteBackgroundLogoPath, updateHeaderLogo } from "./headerUpdate";
import { isLocalized } from "./localizationService";
import { addLocalizationHeaderMenuLocal } from "../../global";
import { logInTestEnv } from "./logger";
import { REGEX } from "../constants/regex";
import { getPageSettings } from "./pageSettings";
import { ScheduleService } from "../hms";
import { startLoader, stopLoader } from "./loader";

interface Operation {
    dayOfWeek: number;
    startMinutes: number;
    endMinutes: number;
  }

export function shareOnFacebook(imageUrl:any, caption:any) {
    // Construct the Facebook sharing URL
    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(imageUrl)}&quote=${encodeURIComponent(caption)}`;

    // Open a new window or tab to share the URL on Facebook
    window.open(shareUrl, '_blank');
}

export function shareOnTwitter(text:any, url:any) {
    const tweetText = encodeURIComponent(text);
    const tweetURL = encodeURIComponent(url);
    const shareURL = `https://twitter.com/intent/tweet?text=${tweetText}&url=${tweetURL}`;

    // Open the tweet URL in a new window
    window.open(shareURL, '_blank');
}


export function shareOnLinkedIn(imageURL:any) {
    // URL of the image you want to share


    // URL for sharing on LinkedIn
    const shareURL = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(imageURL)}`;

    // Open a new window or tab to share the image on LinkedIn
    window.open(shareURL, '_blank');
}

export function shareOnPinterest(imageUrl: any, description:any) {
    // Base Pinterest share URL
    const pinterestShareUrl = 'https://www.pinterest.com/pin/create/button/';
  
    // Parameters
    const urlParams = new URLSearchParams();
    urlParams.append('url', imageUrl); // URL of the image to share
    urlParams.append('description', description);
  
    // Final Pinterest share URL
    const finalUrl = pinterestShareUrl + '?' + urlParams.toString();
  
    // Open the Pinterest share URL in a new window or tab
    window.open(finalUrl, '_blank');
  }
  export function insertAfterUrl(){
    let refresh:any
    if(window.location.pathname.substr(-1) != '/' ){
        refresh= window.location.protocol + "//" + window.location.host + window.location.pathname + '/#thank-you';
    }else {
        refresh= window.location.protocol + "//" + window.location.host + window.location.pathname + '#thank-you';
    }
        
    window.history.pushState({ path: refresh }, '', refresh);
}

export async function getFranchiseWebLocationIdDetails(zipCode:any): Promise<number | string> {
    try {
        const locateLocationRes: any[] = await getFranchiseDetails(zipCode); // IsRoundRobin is true

        if (Array.isArray(locateLocationRes) && locateLocationRes.length > 0) {
            const firstLocation = locateLocationRes[0];
            localStorage.setItem('doingBusinessAs', firstLocation.doingBusinessAs);
            localStorage.setItem('weblocationId', firstLocation.franchiseWebLocationId);
            return firstLocation.hasOwnProperty('franchiseWebLocationId') ? firstLocation.franchiseWebLocationId : "";
        }

        return "";
    } catch (error) {
        console.error('Error in fetching FranchiseLookUpByServiceAddress API data:', error);
        return "";
    }
}

export async function getBrandDetailsFromBrandJson(brandName:string):  Promise<any> {
    try {
        const brandJson = getBrandJSON();
        if(brandJson === 'Error validating Location'){
            console.error("Error Determining BrandJSON path for given location");
            return [];
        }
        else{
            const brandData = localStorage.getItem("brandDetails");
            if(brandData !== "undefined" && brandData !== null){
                let parsedBrandData = JSON.parse(brandData);
                if(parsedBrandData?.code === brandName){
                    if(parsedBrandData?.include_crownpeakURL || parsedBrandData?.include_statename){ 
                        await fetchCrownpeakUrlDetails();
                     } 
                    return parsedBrandData;
                }
            }
            
            const origin = window.location.origin;
            try {
                const url = `${origin}/${brandJson}`;
                const result = await getCachedAPIResponse(url, apiCaching.BrandJsonConfig, false);
                const brandDetails = result.find((item: any) => item.code === brandName);
                let crownpeakUrlDetails = null;
                if(brandDetails?.include_crownpeakURL || brandDetails?.include_statename){ 
                   await fetchCrownpeakUrlDetails();
                } 
                if (brandDetails) {
                  localStorage.setItem("brandDetails", JSON.stringify(brandDetails));
                }
            
                return brandDetails;
              } catch (error:any) {
                const errorMessage = `Error fetching brand details for ${brandName}: ${error.message}`;
                console.error(errorMessage);
                throw new Error(errorMessage);
              }
        }
        

    } catch (error) {
        console.error('Error in fetching getBrandDetailsFromBrandJson API data:', error);
        return [];
    }
}

export function getCountryCodefromAssetpath():string{
    let countryCode:any = document.getElementById('countryCode') as HTMLInputElement;
    countryCode = countryCode?.value.toLocaleLowerCase();
    let assetPath:any = document.getElementById('assetPath') as HTMLInputElement;
    assetPath = assetPath?.value.toLocaleLowerCase();
    const countryCodeFromAsset:string = assetPath?.includes('blogs') ? assetPath?.split('/')[4] : assetPath?.split('/')[5];
    if(countryCode === countryCodeFromAsset){
        return countryCode;
    }
    return countryCodeFromAsset;
}
export function getCampaignName(){
    let hrefUrl = window.location.href;
    let campaignName=''
        if (hrefUrl.indexOf('?') > -1)
        {
            campaignName = hrefUrl;
            sessionStorage.setItem('campaignName', campaignName);
        } else
        {
            campaignName = 'N/A';
        }

        return campaignName;
    }

    export async function commonStates(countryCode:string):  Promise<any> {
        try {
            const stateCaUs = localStorage.getItem(countryCode);
            if(stateCaUs){
                return JSON.parse(stateCaUs);
            }
            const apiUrl = apiConfig.stateApi + countryCode;
            const result :any = await cachedAPIWrapper(apiUrl);
            localStorage.setItem(countryCode, JSON.stringify(result)); 
            return result;
    
        } catch (error) {
            console.error('Error in fetching state API data:', error);
            return [];
        }
    }

    export async function localSearch(){
        const dbaName = document.getElementById('full_dbaName') as HTMLInputElement;
        const country_code = getCountryCodefromAssetpath();
        const url = window.location.origin;   
        try{
            const apiUrl = `${url}/${country_code}/en-${country_code}/_assets/brand/${dbaName?.value}/js/data/dynamic_menu.json`;
            const cachedResponse = await getCachedAPIResponse(apiUrl, apiCaching.DynamicMenu, false);
            if (cachedResponse) {
                const data = cachedResponse.serviceMenu;
                const options = data["country"][0]?.brand[0]?.webLocation[0]?.option;
                const brandMenu = options;
                sessionStorage.setItem('localFilterService', JSON.stringify(brandMenu));
            }
        }
        catch(error){
            console.error('Error in fetching state API data:', error);
        }
    }
    
    export function getFooterLink(){
        try { 
        let data:any = [];
        let dynamicMenuURLResponse: any = {};
            dynamicMenuURLResponse = localStorage.getItem('dynamicMenuURLResponse');
            dynamicMenuURLResponse = JSON.parse(dynamicMenuURLResponse);
            const dynamicServicesMenu:any = dynamicMenuURLResponse?.serviceMenu?.country[0]?.brand[0]?.option;
            dynamicServicesMenu?.forEach((item: any) => {
                data.push({
                    name: item?.name,
                    link: window.location.origin + item?.link

                })
            })
            return data
        } catch(error){
            return [];
        }
    }

    export async function checkOSFlowPathAndReturnBoolean() {

        const conceptCodeElement = document.getElementById('conceptCode') as HTMLInputElement;
        
        if (conceptCodeElement) {

            const conceptCode = conceptCodeElement.value;
            const brandData = await getBrandDetailsFromBrandJson(conceptCode);
            const extractBrandOSFlowPath = brandData.request_button_link_type ? brandData.request_button_link_type.replace(/\//g, "") : "";
            const isApp = window.location.pathname.includes(extractBrandOSFlowPath);
    
            return isApp;
        }
    
        // Handle the case when conceptCodeElement is not found
        return false;
    }

    export async function updateHeaderContent(locationDoingBusinessAs: any) {
        const headerAddress = document.querySelector(".local-location .address") as HTMLElement;
        const headerDescription = document.querySelector(".local-location .description") as HTMLElement;
        const headerLogoLink = document.querySelector(".brand-header-local .brand-logo-wrapper") as HTMLElement;
    
        let trailingSlash = "";
        let hostMapWebLocation = '';

        const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;

        if(conceptCode) {
            const brandData = await getBrandDetailsFromBrandJson(conceptCode);
            if(brandData?.includeTrailingSlash) {
                trailingSlash = "/";
            }

            try {
                let crownpeakUrlDetails = null;
                if(brandData?.include_crownpeakURL || brandData?.include_statename){ // If include_crownpeakURL is true then call Crownpeak URL to localization path
                    await fetchCrownpeakUrlDetails();
                }  
            } catch (error) {
                console.error('Error in fetching Crownpeak API data:', error);
            }
         
            if(brandData?.weblocation_path_group){
                hostMapWebLocation = brandData.weblocation_path_group;
            }
        
            let dba = localStorage.getItem('dbaName') ?? '';
            let dbaName = hostMapWebLocation ? `${hostMapWebLocation}/${dba}`: dba;
            if(brandData?.include_statename){
                const webLocation = window.crownpeakWeblocationsByIdDetail;
                const stateName = webLocation?.stateName;
                if(stateName){
                    dbaName = hostMapWebLocation ? `${hostMapWebLocation}/${stateName}/${dba}`: dba;
                }
            }
            
            updateHeaderElements(locationDoingBusinessAs, headerAddress, headerDescription, headerLogoLink, trailingSlash,dbaName,brandData);
            updateLocalLocationForDesktop();
            updateFooterBrandLogo();
            updateLocalLocationForDevice(trailingSlash,dbaName,brandData);
        }
    }
    
    function updateHeaderElements(
        locationDoingBusinessAs: string,
        headerAddress: HTMLElement,
        headerDescription: HTMLElement,
        headerLogoLink: HTMLElement,
        trailingSlash: string,
        dbaName:any,
        brandData: any
    ) {

        if(headerAddress) {
            headerAddress.innerText = locationDoingBusinessAs;
        }
    
        if(headerDescription && headerDescription.innerText === "") {
            localizationTagLine();
        }   

        const weblocationDetails = window.crownpeakWeblocationsByIdDetail ?? {};
        const domainUrl = getDomainUrl();

        if(headerLogoLink && (brandData?.include_crownpeakURL && weblocationDetails?.weblocation_url) || (weblocationDetails?.weblocation_url && brandData?.include_statename)) {
            
            headerLogoLink.setAttribute("href", weblocationDetails?.weblocation_url);
        }else if(domainUrl && dbaName) {
            headerLogoLink?.setAttribute("href", `${domainUrl}/${dbaName}${trailingSlash}`);
        }
    }
    
    function updateLocalLocationForDesktop() {
        const firstBrandHeaderLocal = document.querySelector(".brand-header-local") as HTMLElement;
        const isLocalized: boolean = localStorage.getItem('dbaName') !== null;
        const pageScope = getPageSettings('pagescope');
        if (firstBrandHeaderLocal && !(isLocalized && pageScope === 'national')) {
            firstBrandHeaderLocal.style.display = ""; // Removes the display attribute
        }
    
        const findLocalLink = document.querySelector(".brand-header-local .find-local") as HTMLElement;
        if(findLocalLink) {
            const textNode = findLocalLink.childNodes[1];
            if (textNode) {
                textNode.textContent = "Change Location";
            }
        }
    }
    
    function updateFooterBrandLogo() {
        const FooterBrandLogo = document.querySelector('.brand-footer .fb-des-link') as HTMLElement;
        if(FooterBrandLogo) {
            replaceLocalLogoLink(FooterBrandLogo);
        }
    }
    
    function updateLocalLocationForDevice(trailingSlash: string,dbaName:any,brandData:any) {
        const isDesktop = reportScreenSize() === ScreenType.Desktop;
        if(!isDesktop) {
            const headerMobileDeviceLogoLink = document.querySelector(".sidenav-brand-logo") as HTMLElement;
            if(headerMobileDeviceLogoLink) {
                headerMobileDeviceLogoLink.setAttribute("href", `${window.location.origin}/${dbaName}${trailingSlash}`);
            }
            const brandLogoMobileDevice = document.querySelector(".brand-logo-mobile") as HTMLElement;
            const weblocationDetails = window.crownpeakWeblocationsByIdDetail ?? {};
            const domainUrl = getDomainUrl();
            if(brandLogoMobileDevice && brandData?.include_crownpeakURL && weblocationDetails?.weblocation_url) {
                brandLogoMobileDevice.setAttribute("href", weblocationDetails?.weblocation_url);
            }else if(domainUrl && dbaName) {
                brandLogoMobileDevice?.setAttribute("href", `${domainUrl}/${dbaName}${trailingSlash}`);
            }
        }
    }

    export function hmsProgressBarUpdate(progressWidth: string,processLength: number){
        const progressBarLine = document.querySelector(".progressbar #progress") as HTMLElement;
        const progresBarItems = document.querySelectorAll(".progressbar .progress-step");
        if(progresBarItems && progressBarLine){
            progressBarLine.style.width = progressWidth;
            progresBarItems.forEach((el, index)=>{
                el.classList.remove("prograssbar-length", "progress-step-confirmed");
                el.classList.remove("prograssbar-length", "progress-step-active");
            })
            
            progresBarItems.forEach((el, index)=>{
                if(index<processLength)
                    el.classList.add("prograssbar-length", "progress-step-confirmed");
                else if(index===(processLength))
                    el.classList.add("prograssbar-length", "progress-step-active");
            })
            
        }
    }

    export function returnToHomePage(){
        let indexUrl = window.location.href;
        const fullUrl = indexUrl.split("/").slice(0, 3).join("/");
        window.location.href = `${fullUrl}/`;
    }
    export function storeBookingApiPayload(payload:any,response:any){
        try{
        const formdata = JSON.stringify(payload);
        sessionStorage.setItem('rl-post-data',formdata);
        let apiData = '{ "Result": '+ JSON.stringify(response) +', "Form data": '+ formdata +', "Response message":"SUCCESS" }';
        sessionStorage.setItem('NEI-API data',apiData);
        } catch(error) {
            console.log("Error while storing the apipayload", error)
        }
    }

    export function removeAllEventListeners(selector: any) {
        const element = document.querySelector(selector);
        if (element) {
            const newElement = element.cloneNode(true);
            element.parentNode.replaceChild(newElement, element);
            return newElement;
        }
        return null;
    }

    export async function getWeblocationPathGroupWithSiteConfig() {
        const url = window.location.origin;
        const dbNameElemet = document.getElementById('dbaName') as HTMLInputElement;
        const dbNameValue = dbNameElemet?.value || localStorage.getItem('dbaName');
        const dbaNameConfig: SiteConfigPathParams = dbNameValue ? { dbName: dbNameValue } : {};
        let dbaName= dbaNameConfig?.dbName ?? '';
        let brandData =  localStorage?.brandDetails ? JSON.parse(localStorage.brandDetails) : null;

        if(!brandData){
            const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
            if(conceptCode){
                brandData = await getBrandDetailsFromBrandJson(conceptCode);
            }
        }
        
        const { weblocation_path_group: hostMapWebLocation,include_statename } = brandData || {};
        let pathSegments = ['config-files', '_site-config.json'];


        if (dbaName) {
            pathSegments.unshift(dbaName);

            if(include_statename){
                let webLocation = window.crownpeakWeblocationsByIdDetail;
                if(!webLocation){
                    await fetchCrownpeakUrlDetails();
                    webLocation = window.crownpeakWeblocationsByIdDetail;    
                }
                const stateName = webLocation?.stateName;
                if(stateName){
                    pathSegments.unshift(stateName);
                }
            }
            if (hostMapWebLocation) {
                pathSegments.unshift(hostMapWebLocation);
            }
        }
        return `${url}/${pathSegments.join('/')}`;
    }

    async function getSiteConfigBasedOnDomain(url:string, pathSegments:string) {
        const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
        if(!conceptCode){
            return;
        }
        const brandData = await getBrandDetailsFromBrandJson(conceptCode);
        if(!brandData?.multiple_domain){
            return;
        }

        const envArray = ['nblydev', 'nblysbx', 'nblytest', 'nblyprod'];
        const isEnvMatch = envArray.some(env => url.includes(env));
        const domain = DomainIdentifier();
        let newConstrunctedUrl = ''
        let newUrl = '';
        if(isEnvMatch){
            if(domain.toLowerCase() === 'ca'){
                newUrl = url.replace(/-ca(-dev|-test|-stage|\.nblyprod)/, '$1');
            }
            else{
                newUrl = url.replace(/(-dev|-test|-stage|\.nblyprod)/, '-ca$1');
            }
        }
        else{
            const originalUrl = url; 
            newUrl = url.replace(/\.(com|net|ca)$/, (match) => {
                if (match === '.com') return '.ca';
                if (match === '.net') return '.ca';
                
                // If it's '.ca', determine whether to switch back to '.com' or '.net'
                return originalUrl.includes('.com') ? '.com' : '.net';
            });
        }
        if(newUrl!==""){
            newConstrunctedUrl = `${newUrl}/${pathSegments}`;
        }
        const [primarySiteConfig, secondarySiteConfig] = await Promise.all([
                getCachedAPIResponse(`${url}/${pathSegments}`, apiCaching.SiteConfig, false),
                getCachedAPIResponse(newConstrunctedUrl, apiCaching.SiteConfig, false),
            ]);
            
            const siteConfig = {
                primarySiteConfig: {},
                secondarySiteConfig: {}
            };
            
            if (primarySiteConfig) {
                siteConfig.primarySiteConfig = primarySiteConfig;
            }
            if (secondarySiteConfig) {
                siteConfig.secondarySiteConfig = secondarySiteConfig;
            }
        sessionStorage.setItem('allSiteConfig', JSON.stringify(siteConfig));
    }   



export function getWeblocationPathGroupWithDynamicConfig() {
    const url = window.location.origin;
    const dbaName: string | null = localStorage.getItem('dbaName');
    const brandName = (document.getElementById('brandName') as HTMLInputElement)?.value;
    const country_code = getCountryCodefromAssetpath();

    let pathSegments = [];

    const localWebID = localStorage.getItem("franchiseWebLocationId");
    const webID = document.getElementById('weblocationId') as HTMLInputElement;
    const weblocationID = webID?.value ? webID?.value : localWebID as string;

    if (dbaName && weblocationID) {
        pathSegments.push('cesmenu', weblocationID, dbaName);
    } else {
        pathSegments.push(country_code, `en-${country_code}`, brandName, '_assets', 'js', 'data', 'dynamic_menu.json');
    }

    return `${url}/${pathSegments.join('/')}`;
}

export async function getWeblocationPathGroupWithFooterConfig() {
    const url = window.location.origin;
    const dbaName: string | null = localStorage.getItem('dbaName');
    const brandData = localStorage?.brandDetails ? JSON.parse(localStorage.brandDetails) : null; 
    const { weblocation_path_group: hostMapWebLocation,include_statename } = brandData || {};

    // Default URL setup
    let pathSegments = ['config-files', '_footer-config'];

    if (dbaName) {
        pathSegments.unshift(dbaName);
        if(include_statename){
            let webLocation = window.crownpeakWeblocationsByIdDetail;
            if(!webLocation){
                await fetchCrownpeakUrlDetails();
                webLocation = window.crownpeakWeblocationsByIdDetail;    
            }
            const stateName = webLocation?.stateName;
            if(stateName){
                pathSegments.unshift(stateName);
            }
        }
        if (hostMapWebLocation) {
            pathSegments.unshift(hostMapWebLocation);
        }
    } 

    return `${url}/${pathSegments.join('/')}`;
}

export async function getFranchiseWebLocationId(zipCode:any): Promise<number | string> {
    try {
        const locateLocationRes: any[] = await getFranchiseDetails(zipCode); // IsRoundRobin is true
        if (Array.isArray(locateLocationRes) && locateLocationRes.length > 0) {
            const firstLocation = locateLocationRes[0];
            return firstLocation
        }

        return "";
    } catch (error) {
        console.error('Error in fetching FranchiseLookUpByServiceAddress API data:', error);
        return "";
    }
}

   export function checkDomain() {
    const url = window.location.origin;
    //for local enviroments
    if(url.includes('localhost')){
        const assetPathElement = document.getElementById("assetPath")as HTMLInputElement;
        if(assetPathElement){
            const assetPathValue = assetPathElement.value;
            if(assetPathValue.includes("/US/"))
                return 'us';
            else if(assetPathValue.includes("/CA/"))
                return 'ca';
        }
        return "Error validating Location"
    }
    //Code for lower enviroments
    else if (url.includes('nblysbx') || url.includes('nblydev') || url.includes('nblytest') || url.includes('nblyprod')){
        try{
            if (url.includes('-ca-') || (url.includes('-ca') &&  url.includes('nblyprod'))){
                return 'ca';
            }
            else{
                return 'us';
            }
        }
        catch{
            return "Error validating Location"
        }
    }
    //Code for production enviroment
    else{
        try{
            const lastDotIndex = url.lastIndexOf('.'); 
            const domainExtension = url.substring(lastDotIndex + 1);
            if(domainExtension === "ca"){
                return 'ca';
            }
            else{
                return 'us';
            }
        }
        catch{
            return "Error validating Location"
        }
    }
    }

    export function capitalizeString(str:string) {
        if (!str) {
            return '';
        }
        return str.charAt(0).toUpperCase() + str.slice(1);
      }

      export function isOperationActiveNow(hoursofOperation: Operation[]): boolean {
        if (!hoursofOperation || hoursofOperation.length === 0) {
          return false;
        }
      
            const now = new Date();
            const currentDayOfWeek = now.getDay();
            const currentMinutes = now.getHours() * 60 + now.getMinutes();
      
        for (const operation of hoursofOperation) {
          if (operation.dayOfWeek == null || operation.startMinutes == null || operation.endMinutes == null) {
            continue;
          }
      
          const dayOfWeek = operation.dayOfWeek;
          const startMinutes = operation.startMinutes;
          const endMinutes = operation.endMinutes;
      
          if (dayOfWeek === currentDayOfWeek && currentMinutes >= startMinutes && currentMinutes <= endMinutes) {
            return true;
          }
        }
      
        return false;
      }

        export function removeElementEventListeners(element: any) {
        if (element) {
            const newElement = element.cloneNode(true);
            element.parentNode.replaceChild(newElement, element);
            return newElement;
        }
        return null;
    }

    export async function getVendorDetails(){
        const conceptId = (document.getElementById('conceptId') as HTMLInputElement)?.value;
        const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
        const brandData = await getBrandDetailsFromBrandJson(conceptCode) as any;
        let vendorId:number = 0,vendorName:string = '';
        if(brandData){
            vendorId = Number(brandData.vendorId) || 0;
            vendorName = brandData.vendorName;
        }
        return {"conceptId": conceptId, "conceptCode": conceptCode, "vendorId": vendorId, "vendorName": vendorName};
    }

export function debounce(func: (...args: any[]) => void, wait: number) {
    let timeout: any;
    return function(this: any, ...args: any[]) {
        if (timeout !== null) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}

function updateInputValue(inputId:string, value:any) {
    try {
        const hiddenInput = document.getElementById(inputId) as HTMLInputElement | null;

        if (hiddenInput && value !== null && value !== undefined) {
            hiddenInput.value = value.toString();
        }
    } catch (error) {
        console.error(`Error in updateInputValue function: ${error}`);
    }
}

declare global {
    interface Window {
        localizationHelper?: any;
    }
}
window.localizationHelper = localizationHelper;

function setDBAName(dbaName: string) {
    if(dbaName){
        localStorage.setItem('dbaName', dbaName);
        localizationTagUpadation();
    }
}
export async function localizationHelper(result:any, isFranchiseWeblocationsGroup?:boolean, agnosticFlow: boolean = true) {
    if(!result || result.length === 0) {
        logInTestEnv('Invalid result data:', result);
        return;
    }
    const { franchiseWebLocationId, doingBusinessAs, franchiseId, phoneNumber,websiteTracking } = result[0];
            
    let pNum = websiteTracking || phoneNumber;

    /** When isFranchiseWeblocationsGroup is true, update localStorage and sessionStorage to handle its different API response structure **/

    let locationUrl = result[0].locationWebsiteUrl?.replace(/\/$/, '') ?? '';
    if(isFranchiseWeblocationsGroup && result[0].websiteUrl) {
        locationUrl = result[0].websiteUrl?.replace(/\/$/, '') ?? '';  
        pNum = result[0]?.websiteTrackingPhone?.length > 0 ? result[0]?.websiteTrackingPhone[0] : phoneNumber;
    }

    // Localization related code
    localStorage.setItem("franchiseWebLocationId", franchiseWebLocationId);
    sessionStorage.setItem('franchiseId', franchiseId);
    localStorage.setItem('doingBusinessAs', doingBusinessAs);
    localStorage.setItem('weblocationId', franchiseWebLocationId);
    localStorage.setItem('localPhoneNumber',pNum);
    sessionStorage.setItem("RL_Weblocation_ID", franchiseWebLocationId);
    sessionStorage.setItem("RL_DBAName", doingBusinessAs);

    const splitUrlArr = locationUrl.toLowerCase().split("/");
    const pathname = splitUrlArr[splitUrlArr.length - 1];
    
    const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
    const brandData = await getBrandDetailsFromBrandJson(conceptCode);
    if (brandData?.displayCESurl) {
        await fetchCrownpeakUrlDetails();
        const weblocationId = franchiseWebLocationId;
        const crownpeakWeblocationsDetails = window.crownpeakWeblocationsDetails;
        const matchingWeblocation = crownpeakWeblocationsDetails?.find(
            (weblocation: { weblocation_id: string }) => weblocation.weblocation_id == weblocationId
        );
        setDBAName(matchingWeblocation?.dbaName ?? pathname);
    } else {
        setDBAName(pathname);
    }
    updateInputValue("local_weblocationId", franchiseWebLocationId);
    updateInputValue("weblocationId", franchiseWebLocationId);
    updateInputValue("full_dbaName", pathname);
    updateInputValue("dbaName", pathname);

    const address = document.querySelector('.header-wrapper .address')
    const desc = document.querySelector('.header-wrapper .description')
    const phone = document.querySelector('.header-wrapper .form-call-cta') as HTMLAnchorElement;
    const mobile = document.querySelector('.header-cta-mobile .mob-call-cta') as HTMLAnchorElement;

    // Cross domain link update for mobile and desktop
    handleCrossDomainLink(locationUrl);

    if (pathname && doingBusinessAs) {
        updateHeaderContent(doingBusinessAs);
    }

    if (address && desc && phone) {
        address.innerHTML = doingBusinessAs
        localizationTagLine();
        phone.href = `tel:${pNum}`;
        phone.innerText = `(${pNum.slice(0, 3)}) ${pNum.slice(3, 6)}-${pNum.slice(6)}`;
    }

    if (mobile) {
        mobile.href = `tel:${pNum}`;
    }

    localizationMobileDBATitle();

    if(agnosticFlow) {
        //Update the local header to display the DBA name centered when the user is localized.
        try {
            await addLocalizationHeaderMenuLocal();
        } catch (error) {
            logInTestEnv('Error in addLocalizationHeaderMenuLocal function:', error);
        }
        // END
        const ft_footer = Footer.init();
    }
}

declare global {
    interface Window {
        crownpeakWeblocationsDetails?: any;
        crownpeakWeblocationsByIdDetail?: any;
    }
}

export function closeReminderModal(){
    const closeModal = document.getElementById('close-reminder-local-modal');
    if (closeModal) {
        closeModal.click();
    }
}

//Code to handle Fake Submit (US:447017- Implement a Way to Test Full Booking Flow in Production)
export function handleFakeSubmit(request:any) {
    requestLogger(request.data, request.url);
    return Promise.resolve();
}

export function logPayloadForFakeSubmit(){
    if(sessionStorage.getItem('mockRequestPayload')){
        console.log('%c[FAKE BOOKING]%c Mock Request Payload :','background:green; color:#f3f3f3; font-weight: bold; padding: 0 8px; font-size:1.2rem', '', sessionStorage.getItem('mockRequestPayload'))
    }
}

export function weblocationDetailsById(){
    try {
        const franchiseWebLocationId = localStorage.getItem("franchiseWebLocationId") ?? localStorage.getItem('weblocationId') ;
        const weblocationDetails = window.crownpeakWeblocationsDetails ?? {};
        const weblocation = weblocationDetails.find((item: any) => item.weblocation_id == franchiseWebLocationId);
        return weblocation;

    } catch (error) {
        console.error('Error in fetching Crownpeak API data:', error);
        return {};
        
    }
}
  
  interface Franchise {
    franchiseDetails: FranchiseDetail[];
  }
  
  interface CrownpeakData {
    weblocation_id: string;
    weblocation_url: string;
    }  

export function updateFranchiseDataWithCrownpeakData(franchiseData: any[]): Franchise[] {
    // Create a map for fast lookup of crownpeak data by weblocation_id
    const crownpeakData:CrownpeakData[] = window.crownpeakWeblocationsDetails ?? [];
    console.log("Before updating-------->",crownpeakData)
    const crownpeakMap = new Map<string, string>();
    crownpeakData?.forEach(crown => {
        crownpeakMap.set(crown.weblocation_id, crown.weblocation_url);
    });
    console.log("After updating-------->",crownpeakData)

    // Iterate over franchise data
    franchiseData?.forEach(franchise => {
        // franchise?.forEach((detail: any) => {
            // Find matching weblocation_id from crownpeak map
            if(franchise.franchiseWebLocationId){
                const franchiseWebLocationIdStr = franchise.franchiseWebLocationId.toString();
                const matchedCrownpeakUrl = crownpeakMap.get(franchiseWebLocationIdStr);
                // If a match is found, update the weblocation_url
                if (matchedCrownpeakUrl) {
                    franchise.crownpeak_weblocation_url = matchedCrownpeakUrl;
                }
            }
        // });
    });
    console.log("After updating--------> Franchise",franchiseData)
    return franchiseData;
  }

  export async function fetchCrownpeakUrlDetails(): Promise<any> {
    const crownpeakURL = apiConfig.CROWNPEAK_WEBLOCATION_URL;
    const crownpeakUrlDetails:any = await getCachedAPIResponse(crownpeakURL, 60, false);
    window.crownpeakWeblocationsDetails = crownpeakUrlDetails;
    window.crownpeakWeblocationsByIdDetail = weblocationDetailsById();
}

export async function getFullAttributeData(webId:string): Promise<any> {
    try {
        const url = `${apiConfig.GET_ATTRIBUTE_DATA}/${webId}`;
        const response = await cachedAPIWrapper(url);
        if (!response || Object.keys(response).length === 0) {
            console.warn('No data found for the provided webId:', webId);
            return null;
        }
        localStorage.setItem("fullAttrOnLoad", JSON.stringify(response));
        return response;
    } catch (error) {
        console.error('Error fetching full attribute data:', error);
        return null;
    }
}

export async function getPostalCodeForLocalizedLink(webId:string): Promise<string> {
    let result = '';
    try{
        const parsedData = await getFullAttributeData(webId);
        if (!parsedData || Object.keys(parsedData).length === 0) {
            return '';
        }
        result = parsedData?.zip || '';
        if(!result) return '';
        return result.trim();
    }
    catch(error){
        console.error('Error fetching postal code for localized link:', error);
        return '';
    }

}

export function getWebLocationId(){
    let webId:string|null = ((document.getElementById('weblocationId') as HTMLInputElement)?.value ?? localStorage.getItem("franchiseWebLocationId"));
    if(!webId){
        webId = localStorage.getItem('weblocationId') || localStorage.getItem('local_weblocationId');
    }
    if (webId === "undefined" || webId === "null" || !webId) { 
        return null; 
    }
    return webId;
}

export async function getSiteConfigApplyLocallyFlag() {
    const urlSiteConfig = await getWeblocationPathGroupWithSiteConfig();
    if (!urlSiteConfig) return false;
    try {
        const cachedResponse = await getCachedAPIResponse(urlSiteConfig, apiCaching.SiteConfig, false);
        if(cachedResponse) {
            return !(cachedResponse?.chk_disable_job_link_localization ?? false);
        }
        return false;
    } catch {
        console.error("Error in fetching site config");
        return false;
    }
}

 export async function modifyAllApplyLocalHref() {
    const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
    if(!conceptCode) return;
    const brandData = await getBrandDetailsFromBrandJson(conceptCode);
    const siteConfigApplyLocallyFlag = await getSiteConfigApplyLocallyFlag();
    const webID = getWebLocationId();
    if(!webID) return;
    if(brandData?.job_link_localisation && siteConfigApplyLocallyFlag) {
        let zipCodeData = await getPostalCodeForLocalizedLink(webID);
        if(!zipCodeData) return;
        const selectors = [
            '.brand-header ul.brand-cta-list li.brand-cta-item a[aria-labelledby="Apply Locally"]',
            '.brand-header ul.brand-cta-list li.brand-cta-item a[aria-labelledby="Aplicar Localmente"]',
            '.brand-header-local ul.brand-cta-list li.brand-cta-item a[aria-labelledby="Apply Locally"]',
            '.brand-header-local ul.brand-cta-list li.brand-cta-item a[aria-labelledby="Aplicar Localmente"]',
            '.brand-footer .footer-block .fb-wrapper-link .fb-link-block ul.footer-submenu li.submenu-li a[title="Apply Locally - opens in a new tab"]',
            '.brand-footer .footer-block .fb-wrapper-link .fb-link-block ul.footer-submenu li.submenu-li a[title="Aplicar Localmente - opens in a new tab"]',
            '.brand-footer .fb-inner-wrapper .fb-wrapper-link a[title="Apply Locally"]',
            '.brand-footer .fb-inner-wrapper .fb-wrapper-link a[title="Aplicar Localmente"]',
            '.main-nav-warpper a[title="Apply Locally - open in new tab"]',
            '.team-neighborly-section a[title^="View All Positions"]',
            '.team-neighborly-section a[title^="View All Open Positions"]'
        ];
    
        const DEFAULT_US_RADIUS = "25";
        const DEFAULT_CANADA_RADIUS = "100";
        const CA_RADIUS = brandData?.localization_radius || DEFAULT_CANADA_RADIUS;
        const US_RADIUS = brandData?.localization_radius || DEFAULT_US_RADIUS;
        
        // Determine TLD by country code (us => .com, ca => .ca)
        const country = checkDomain();
        const isCA = country?.toLowerCase() === 'ca';
        const zipRegexCA = /[a-zA-Z]/;
        const isUSDomainCanadaZipcode = zipRegexCA.test(zipCodeData); 
        // Determine radius based on country and zip code format
        let radius: string;
        if (isCA) {
            radius = CA_RADIUS;
        } else if (isUSDomainCanadaZipcode) {
            radius = DEFAULT_CANADA_RADIUS;
        } else {
            radius = US_RADIUS;
        }

        // Construct job URL objects with same query params
        const jobUrlQueryParams = [
            [
                "location_name",
                zipCodeData
            ],
            [
                "location_type",
                "1"
            ],
            [
                "radius",
                radius
            ]
        ];
    
        const applyLinks = document.querySelectorAll(selectors.join(','));
        applyLinks.forEach((node) => {
            try {
                const linkEl = node as HTMLAnchorElement;
                if (!linkEl) return;
                if (!linkEl.href || linkEl.getAttribute('href')?.startsWith('javascript:')) return;
                const url = new URL(linkEl.href);
                if (!url.pathname)
                    url.pathname = '/jobs';
                else if (!url.pathname.includes('jobs')) {
                    const baseUrl = url.pathname.endsWith('/') ? url.pathname : `${url.pathname}/`;
                    url.pathname = `${baseUrl}jobs`;
                }
                const params = new URLSearchParams(url.search);
                for (let [key, value] of jobUrlQueryParams) {
                    if (!params.has(key)) {
                        params.append(key, value);
                    }
                }
                url.search = params.toString();
                linkEl.href = url.toString();
            } catch (error) {
                console.error('Error setting Apply Locally href:', error);
            }
        });
    }
}

export async function loadHereMapScripts(): Promise<void> {
    const isScriptLoaded = document.getElementById('mapsjs-core-js');
    if (!isScriptLoaded) {
        const cacheBuster = `cb=${Date.now()}`;
        const loadScript = (url: string, id: string) => {
            return new Promise<void>((resolve, reject) => {
                const elem = document.createElement("script");
                elem.async = false;
                elem.src = `${url}?${cacheBuster}`;
                elem.id = id;
                elem.onload = () => resolve();
                elem.onerror = () => reject(new Error(`Failed to load script: ${url}`));
                document.head.appendChild(elem);
            });
        };

        await Promise.all([
            loadScript('https://js.api.here.com/v3/3.1/mapsjs-core.js', 'mapsjs-core-js'),
            loadScript('https://js.api.here.com/v3/3.1/mapsjs-ui.js', 'mapsjs-ui-js'),
        ]);
    } else {
        // Optionally, re-initialize the map here if needed
        console.log('Here Map scripts are already loaded.');
    }
}

export function isNegative(number: number): boolean {
    let isNegative = number < 0;
    return isNegative;
}

export async function getFranchiseDetails(addressParam: string, isRoundRobin: boolean = true, serviceId?: any): Promise<any> {
    const conceptID = getConceptId();
    let url = `${apiConfig.LocateLocationApiWithRoundRobin}/${normalizeUSZipCode(addressParam)}/${isRoundRobin}/true/${conceptID}`;
    if (serviceId) {
        url += `/${serviceId}`;
    }
    return cachedAPIWrapper(url);
}

export const getConceptId = (): string => 
    {
        const conceptId = (document.getElementById('conceptId') as HTMLInputElement)?.value;
        return conceptId;
    }
export function hideErrorMsgInModal():void{
    const htmlEle = document.querySelectorAll('.error-text-wrapper .modal-text');
    if(htmlEle?.length>0){
    Array.from(htmlEle).forEach((ele)=>ele?.classList.add('hidden'))
    }
}

export function constructAppointMentApiUrl(params: TechAvailabilityParams): string {
      const baseUrl = apiConfig.AppointMentAPi;
      const queryParams = new URLSearchParams({
        PostalCode: params.PostalCode,
        WebLocationId: params.WebLocationId,
        DateStart: params.DateStart,
        IsEstimate: params.IsEstimate.toString(),
        VendorId: params.VendorId.toString()
      });

      // Append optional parameter if available

      if(params.apikey) {
        queryParams.append("apikey", params.apikey);
      }

      if(params.NumberOfDays) {
        queryParams.append("NumberOfDays", params.NumberOfDays.toString());
      }

      let calendarTypeId = window.calendarTypeId;
      if (calendarTypeId == 2 && params.ServiceSkuId) {
        queryParams.append("ServiceSkuId", params.ServiceSkuId);
      }
    
      return `${baseUrl}?${queryParams.toString()}`;
}
export function setLocalTagLineText(cachedResponse: any): void {
    if (cachedResponse) {
        if(isLocalized()){
                const locateSubTitle = cachedResponse?.locateSubTitle ?? "Locally Owned and Operated";

                if (locateSubTitle) {
                    localStorage.setItem('localTagLine', locateSubTitle);
                    localizationTagLine();
                }
                const headerLogoURL = cachedResponse?.headerLogo?.logoImage;
                const headerLogoAlt = cachedResponse?.headerLogo?.logoAltText;
                const hamburgerViewLogoImage = cachedResponse?.headerLogo?.hamburgerViewLogoImage;
                if (headerLogoURL) {
                    updateHeaderLogo(headerLogoURL, headerLogoAlt ?? "Brand Logo",hamburgerViewLogoImage);
                }else if (hamburgerViewLogoImage) {
                    changeWhiteBackgroundLogoPath(hamburgerViewLogoImage, headerLogoAlt ?? "Brand Logo");
                }

                // Setting session storgae for header logo for Agnostic flow 
                if(cachedResponse?.headerLogo){
                    sessionStorage.setItem('headerLogoURL', JSON.stringify(cachedResponse?.headerLogo));
                }
            
        }
    }
}

export function handleCrossDomainLink(locationUrl: string): void {
    // Reset the localstorage value if the domain is not same as current domain
    localStorage.removeItem('locationWebsiteUrl');

        try {
            // Extracting the domain name from the locationUrl
            const url = new URL(locationUrl);
            if (url?.origin) {
                localStorage.setItem('locationWebsiteUrl', url.origin);
            }
        } catch (error) {
            console.error('Error processing cross-domain link:', error);
        }
}

export function getDomainUrl(): string {
    const locationWebsiteUrl = localStorage.getItem('locationWebsiteUrl');
    return locationWebsiteUrl ?? window.location.origin;
}

// Method to return a Promise with the result of the API call to validate email
export async function isValidEmail() : Promise<boolean> {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(true);
      }, 200); 
    });
}

export function calculateCaretPosition(element: any, selectionStart: any, originalLength: any) {
    // Calculate new caret position
    if(element) {
        const positionDiff = element?.value ? element.value.length - originalLength.length : 0;
        const newCaretPos = selectionStart + positionDiff;
        element.setSelectionRange(element.selectionStart, newCaretPos);
    }
}

export const determineCountryZip = (zipcode: string): string => {
    if (zipcode) {
      return !REGEX.sendCaPostalCode.test(zipcode.trim()) ? 'us' : 'ca';
    }
    return 'us';
  };

export const handleGetFallbackLocationData = async () => {
    const weblocationId = localStorage.getItem("weblocationId");
    if (!weblocationId) {
        return { state: 'No state found', city: 'No city found' };
    } 
    try {
        const url = `${apiConfig.GET_ATTRIBUTE_DATA}/${weblocationId}`;
        const result = await cachedAPIWrapper(url);
    
        return {
          state: result?.state ?? 'No state found',
          city: result?.city ?? 'No city found',
        };
    } catch (error) {
        console.error("Failed get attribute api call:", error);
        return { state: 'No state found', city: 'No city found' };
    }
}

export const getAddressLine = (franchiseDetails:FranchiseDetail,modelText:boolean=false): string => {
    // Check if displayAddressSwitch is true and address1 or address2 is not empty & add with span tag
    if (!franchiseDetails.displayAddressSwitch) {
        return '';
    }
    if (franchiseDetails.address1 && franchiseDetails.address2) {
        return `<span class="${modelText ? 'modal-text' : ''}">${franchiseDetails.address1}, ${franchiseDetails.address2}</span>`;
    } else if (franchiseDetails.address1) {
        return `<span class="${modelText ? 'modal-text' : ''}">${franchiseDetails.address1}, </span>`;
    } else if (franchiseDetails.address2) {
        return `<span class="${modelText ? 'modal-text' : ''}">${franchiseDetails.address2}, </span>`;
    }
    return '';
};

export const rearrangeCanadaFirst = (data: FranchiseDetail[]) => {
    const canada: FranchiseDetail[] = [];
    const others: FranchiseDetail[] = [];

    data.forEach(item => {
        const country = item.country?.toLowerCase();
        if (country === 'can' || country === 'ca' || country === 'canada') {
            canada.push(item);
        } else {
            others.push(item);
        }
    });

    const result = [...canada, ...others];

    return result;
}

export function getCookie(key: string): string {
    const name = key + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (const cRaw of ca) {
        let c = cRaw.trim();
        if (c.startsWith(name)) {
            return c.substring(name.length);
        }
    }
    return "";
}

export function normalizeUSZipCode(zipCode: string): string {
    try {
        if (!zipCode) {
            return '';
        }
        zipCode = zipCode.trim();
        const hasHyphenInZipCode = zipCode.includes('-');
        // Check if Zip Code US format is valid
        const USZipCodeRegex = /^\d{5}(-\d{4})?$/;

        if (USZipCodeRegex.test(zipCode) && hasHyphenInZipCode) {
            const baseZipCode = zipCode.split('-')[0];
            zipCode = baseZipCode?.trim();
        }
        return zipCode;
    } catch (error) {
        console.error('Error normalizing us zip code:', error);
        return zipCode;
    }
}

export function filterFranchiseData(data: any) {
    const countryCode = (document.getElementById("countryCode") as HTMLInputElement)?.value.toLowerCase();
    let details = data.flatMap((f: { franchiseDetails: any[]; franchiseId: any; }) =>
      f.franchiseDetails.map(detail => ({
        ...detail,
        franchiseId: f.franchiseId,
        distance: detail?.distanceFromPostalCode ? detail?.distanceFromPostalCode : detail?.distance
      }))
    );
    if (countryCode === 'us') {
      details = details.filter((c: any) => c.country === 'USA' || c.country === 'United States');
    } else {
      details = details.filter((c: any) => c.country === 'CAN' || c.country === 'Canada');
    }
    // Removing duplicates
    let result = [];
    const set = new Set();
    for (let detail of details) {
      const businessName = detail?.doingBusinessAs?.toLocaleLowerCase() ?? "";
      const isTestAccount = businessName.includes("test account");
      const isDemoAccount = businessName.includes("demo");
      if (!set.has(detail.franchiseWebLocationId) && !isTestAccount && !isDemoAccount) {
        result.push(detail);
        set.add(detail.franchiseWebLocationId);
      }
    }
    return result;
  }

export function detectServicePageTypeByAssetPath(): Promise<string | null> {
    return new Promise((resolve) => {
        const assetPathInput = document.getElementById('assetPath') as HTMLInputElement;
        const pageType = (document.getElementById('pageType') as HTMLInputElement)?.value;
        
        if (!assetPathInput?.value) {
            sessionStorage.removeItem('serviceType');
            resolve(null);
            return;
        }
        const assetPath = assetPathInput.value;
        if (pageType !== 'Opus 2 Agnostic Lead Flow Template' && (!assetPath.includes('/Services') && !assetPath.includes('/Other Services'))) {
            sessionStorage.removeItem('serviceType');
            resolve(null);
            return;
        }
        // Extract the path after /Services or /Other Services
        const servicesRegex = /\/Services(.+)/i;
        const otherServicesRegex = /\/Other Services(.+)/i;
        
        const servicesMatch = servicesRegex.exec(assetPath);
        const otherServicesMatch = otherServicesRegex.exec(assetPath);
        
        const servicePath = servicesMatch?.[1] || otherServicesMatch?.[1];
        
        if (servicePath) {
            // Extract the first segment after /Services or /Other Services
            const serviceType = servicePath.split('/').find(segment => segment.trim() !== '')?.toLowerCase();
            
            if (serviceType) {
                sessionStorage.setItem('serviceType', serviceType);
                resolve(serviceType);
                return;
            }
        }
        
        resolve(null);
    });
}

export function detectPageTypeByAssetPath(
    pageToDetect: string, 
    sessionKey: string, 
    extractionLogic?: (assetPath: string) => string,
): Promise<boolean> {
    return new Promise((resolve) => {
        const pageType = (document.getElementById('pageType') as HTMLInputElement)?.value;
        const assetPathInput = document.getElementById('assetPath') as HTMLInputElement;
        const assetPath = assetPathInput?.value;
        
        // Early exit if no asset path
        if (!assetPath) {
            sessionStorage.removeItem(sessionKey);
            resolve(false);
            return;
        }

        // Extract value using custom logic or default to final path segment
        const extractedValue = extractionLogic 
            ? extractionLogic(assetPath)
            : assetPath.split('/').pop() || '';
        
        const isMatch = extractedValue.toLowerCase().includes(pageToDetect.toLowerCase());
        const isAgnosticLeadFlowTemplate = pageType === 'Opus 2 Agnostic Lead Flow Template';

        if (isMatch) {
            sessionStorage.setItem(sessionKey, 'true');
            resolve(true);
        } else {
            // Only remove session storage for non Lead-flow templates
            if (!isAgnosticLeadFlowTemplate) {
                sessionStorage.removeItem(sessionKey);
            }
            resolve(false);
        }
    });
}

export function detectFinancingPage(): Promise<boolean> {
    return detectPageTypeByAssetPath('financing', 'leadFlowFromFinancingPage');
}

export async function isISNFlow(franchiseDetail: any, zipCode: any, redirectLink: any) {
    try {
        if (!franchiseDetail?.franchiseWebLocationMarketingId) return false;
        await getOnlineSchedulingWithWeblocation(franchiseDetail, zipCode, redirectLink);
    } catch (error) {
        console.error('Error in isISNFlow function:', error);
        return false;
    }
}

async function getOnlineSchedulingWithWeblocation(franchiseDetail: any, zipCode: any, redirectLink: any) {
    startLoader();
    const url = `${apiConfig.GET_ATTRIBUTE_DATA}/${franchiseDetail.franchiseWebLocationId}`;
    const scheduleService = ScheduleService.getInstance();
    if(franchiseDetail){
        scheduleService.POSObject = franchiseDetail;
    }
    try {
        const resp = await cachedAPIWrapper(url, apiCaching.FullAttributeResponse);
        //This is to localize the data
        await scheduleService?.setLocalData(resp, "");
        if (resp?.onlineScheduling) {
            redirectToExternalSite(franchiseDetail.franchiseWebLocationMarketingId, redirectLink);
        }
        else {
            window.open(redirectLink, '_blank');
        }
        stopLoader();
    }
    catch {
        stopLoader();
        console.error(`Error fetching POS systems for weblocationID: ${franchiseDetail.franchiseWebLocationId}`);
        window.open(redirectLink, '_blank')
    }
}


async function redirectToExternalSite(franchiseNumberToCheck: any,  redirectLink: any) {
    startLoader();
    const scheduleService = ScheduleService.getInstance();
    try {
        const URL = scheduleService.getRedirectConfigUrl();
        const result = await getCachedAPIResponse(URL, apiCaching.IsnRedirectConfig, false);
        stopLoader();
        const franchiseObj = result.find((obj: any) => obj.franchisee_number === franchiseNumberToCheck);
        if (franchiseObj.isnUrl === String.raw`\N`) {
            window.open(redirectLink, '_blank')
        } else {
            scheduleService.triggerGTMEvent(franchiseObj.isnUrl);
            scheduleService.handlePopupWindow(franchiseObj.isnUrl);
        }
    } catch {
        stopLoader();
        console.error(`Error fetching ISN redirect config from CP`);
        window.open(redirectLink, '_blank')
    }
}

